import React, { useState } from "react";
import SnackBar from "my-react-snackbar";

const FORMSPARK_URL = "https://submit-form.com/pX0haDLD";

function Contact() {
  const [message, setMessage] = useState("");
  const [email, setEmail] = useState("");
  const [open, setOpen] = useState(false);
  const [disable, setDisable] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setDisable(true);
    await fetch(FORMSPARK_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        email,
        message,
      }),
    });
    setOpen(true);
    setEmail("");
    setMessage("");
    setTimeout(() => setDisable(false), 2000);
  };

  return (
    <section id="contact" className="contact section-bg">
      <div className="container" data-aos="fade-up">
        <div className="section-title">
          <span className="section-index">09 — Contact</span>
          <h2 style={{ fontWeight: "bold", color: "var(--text-color)" }}>
            Get in Touch
          </h2>
          <p style={{ color: "var(--text-color-secondary)", marginTop: "10px" }}>
            Feel free to reach out for collaborations, opportunities, or just to say hello!
          </p>
        </div>
        <div id="contact-form">
          <form onSubmit={onSubmit}>
            <input
              id="email"
              type="email"
              name="email"
              placeholder="Your Email Address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={{
                background: "var(--card-bg)",
                color: "var(--text-color)",
                border: `1px solid var(--border-color)`,
              }}
            />
            <textarea
              id="message"
              type="text"
              name="message"
              placeholder="Your Message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              required
              style={{
                background: "var(--card-bg)",
                color: "var(--text-color)",
                border: `1px solid var(--border-color)`,
              }}
            ></textarea>
            <button 
              type="submit" 
              disabled={disable}
              style={{
                background: disable ? "var(--text-color-secondary)" : "var(--primary-color)",
                cursor: disable ? "not-allowed" : "pointer",
              }}
            >
              {disable ? "Sending..." : "Send Message"}
            </button>
          </form>
        </div>
      </div>
      <SnackBar
        open={open}
        message={"Your message has been sent successfully! 🎉"}
        position="bottom-left"
        type="success"
        yesLabel="Great!"
        timeout={3000}
        onYes={() => {
          setOpen(false);
        }}
        closeOnClick={true}
      />
    </section>
  );
}

export default Contact;
